module.exports = __webpack_public_path__ + "img/zkt-icon.874aefd6.jpg";